module.exports = __webpack_public_path__ + "static/ogp-0c6b53eeba228dc117175efa3b20a063.png";